<div class="input-inline">
    <ng-container *ngIf="!isShowInput">
        <div *ngIf="!editByPen" class="input-text">
			<span (click)="onShowInput()" *ngIf="value && !bold"
                  data-action="activateInput">{{ value }}</span>
            <strong (click)="onShowInput()" *ngIf="value && bold"
                    data-action="activateInput">{{ value }}</strong>
            <i (click)="onShowInput()" *ngIf="!value" data-action="activateInput"
               style="font-weight: 500;">{{ 'MODALS.FIELDS.SELECT.EMPTY' | translate }}</i>
        </div>
        <div *ngIf="editByPen">
            <strong *ngIf="value && bold">{{ value }}</strong>
            <span *ngIf="value && !bold">{{ value }}</span>
            <i *ngIf="!value">{{ value }}</i>
            <i (click)="onShowInput($event)" class="bi bi-pen" ngbTooltip="{{ 'BUTTON_TEXT.EDIT' | translate }}"
               style="margin-left: 10px"></i>
        </div>
    </ng-container>
    <ng-container *ngIf="isShowInput">
        <input #input [value]="value" class="form-control">
        <div class="btn-group">
            <button (click)="onSave(input)" class="btn btn-success" data-action="confirmInput">
                <i class="bi bi-check"></i>
            </button>
            <button (click)="onCancel()" class="btn btn-danger" data-action="cancelInput">
                <i class="bi bi-x"></i>
            </button>
        </div>
    </ng-container>
</div>
